import { Classes } from "@blueprintjs/core";
import React from "react";
import { Field } from "typegraph";

import CountResult from "common/entities/CountResult";
import { ID } from "common/entities/IEntity";
import { IPageableListQuery } from "common/models/IPageableListQuery";
import PageLinkView from "common/views/pageLink/PageLink.view";
import { EntityTable } from "core/components/EntityTable";
import constants from "../../constants";
import { ArticleContributor } from "../entities";


function mapQueryParams(args: any) {

	const params = {};

	Object.entries(args).forEach(([key, value]) => {

		if (value) {
			params[key] = value;
		}
	});

	return { params };
}

class ArticleContributorQuery implements IPageableListQuery<ArticleContributor> {

	@Field({
		entity: ArticleContributor,
		aliasFor: "articleContributor_many",
		params: mapQueryParams
	})
	public entities: null | ArticleContributor[];

	@Field({
		entity: CountResult,
		aliasFor: "articleContributor_count",
		params: mapQueryParams
	})
	public count: CountResult;

}

interface IArticleContributorListProps {
	articleId: ID;
}

export function ArticleContributorList(props: IArticleContributorListProps) {

	const params = {};

	if (props.articleId) {
		params['articleId'] = props.articleId;
	} else {
		return null;
	}

	return (
		<EntityTable
			pagingQuery={ArticleContributorQuery}
			formClass={ArticleContributor}
			params={params}
			columns={[
				{
					key: 'name',
					label: 'Contributor',
					sort: 'cont.name',
					renderCell: ({data}) => (
						<PageLinkView
							viewKey="contributor.link"
							className={Classes.BUTTON}
							preserveParams={false}
							params={{[constants.PARAM_CONTRIBUTOR_ID]: data.contributor.id}}
						>
							{data.contributor && data.contributor.name || null}
						</PageLinkView>
					)
				},
				{
					key: 'primary',
					label: 'Primary Contributor',
					sort: 'primary',
					renderCell: ({data}) => (data.primary).toString()
				},
				{
					key: 'sortIndex',
					label: 'Sort Index',
					sort: 'sortIndex',
					renderCell: ({data}) => (data.sortIndex).toString()
				}
			]}
			updateExcludeFields={['contributor']}
			onBeforeSave={
				(o) => {

					const actionParams = {};

					if (o.id) {
						actionParams['id'] = o.id;
					} else {
						actionParams['contributorId'] = o.contributor.id;
						actionParams['articleId'] = props.articleId;
					}

					actionParams['sortIndex'] = o.sortIndex || 0;

					if (o.description) {
						actionParams['description'] = o.description;
					}

					actionParams['primary'] = o.primary || false;

					return actionParams;
				}
			}
		/>
	);
}



// WEBPACK FOOTER //
// ./src/panels/kb/articleContributor/admin/ArticleContributorList.tsx